import ExaminationParticipantForm, {
  ExaminationParticipantFormProps,
  ParticipantTab,
} from './ExaminationParticipantForm';

export { ParticipantTab };
export type { ExaminationParticipantFormProps };
export default ExaminationParticipantForm;
